import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const Loader = ({ message = "Loading..." }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                bgcolor: "rgba(0, 0, 0, 0.5)",
                zIndex: 9999,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                color: theme.palette.text.primary,
                backdropFilter: "blur(2px)",
            }}
        >
            <CircularProgress color="primary" sx={{ mb: 2 }} />
            <Typography>{message}</Typography>
        </Box>
    );
};

export default Loader;